import { mapState, mapGetters, mapActions } from 'vuex'

export const cooperationComputed = {
  ...mapState('cooperation', {
    userGroupDetail: (state) => state.userGroupDetail,
  }),
  ...mapGetters('cooperation', [
    'getUserGroupDetail',
    'getListSettingUser',
    'getUserMaxNum',
    'updateListSettingUser',
    'updateListSettingSuccess',
    'getIsLoading',
  ]),
}

export const cooperationMethods = mapActions('cooperation', [
  'getUserGroupList',
  'getListSettingParams',
  'getUserMaxNumParams',
  'updateListSettingParams',
])
